import React, { Fragment } from "react";
import { ErrorBoundary } from "components";

const EmptyLayout = (props) => (
  <Fragment>
    <div>
      <ErrorBoundary>{props.children}</ErrorBoundary>
    </div>
  </Fragment>
);

export default EmptyLayout;
